import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { reduxForm, formValueSelector, InjectedFormProps } from 'redux-form';
import { ThunkDispatch } from 'redux-thunk';

import { loadJobDetails } from '../../action/job/load-job-details';
import { jobDetailsSelector } from '../../reducers/job-selectors';

import { JobFieldApplicantScoreThreshold } from '../../job/fields/job-field-applicant-score-threshold';
import { JobFieldContactInfo } from '../../job/fields/job-field-contact-info';
import { JobFieldNotificationSettings } from '../../job/fields/job-field-notification-settings';

import { JobFlowButtons } from './job-flow-buttons';

import { NOTIFICATION_TYPES } from '../../util/notification-types';

const FORM_NAME = 'jobFlowNotifications';

const mapStateToProps = (state: any, ownProps: InputProps) => {
  const jobDetails = ownProps.job.job_id
    ? jobDetailsSelector(state, ownProps.job.job_id)
    : undefined;
  const selector = formValueSelector(FORM_NAME);

  return {
    forwardingPhoneNumber: selector(state, 'forwardingPhoneNumber'),
    notificationSettings: selector(state, 'notificationSettings'),
    initialValues: {
      notificationSettings: jobDetails?.notificationSettings,
      forwardingPhoneNumber: ownProps.job.forwardingPhoneNumber,
    },
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadJobDetails: () =>
      ownProps.job.job_id ? dispatch(loadJobDetails(ownProps.job.job_id)) : undefined,
  },
});

interface InputProps extends JobFlowStep {
  job: Partial<Job>;
}

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type JobFlowNotificationsComponentProps = InputProps & StateProps & DispatchProps;
type JobFlowNotificationsFields = Partial<Job>;
type Props = InjectedFormProps<JobFlowNotificationsFields, JobFlowNotificationsComponentProps> &
  JobFlowNotificationsComponentProps;

class JobFlowNotificationsComponent extends React.PureComponent<Props> {
  submit = (job: JobFlowNotificationsFields) => {
    this.props.onNext(job);
  };

  hasTextNotification = () => {
    const { forwardingPhoneNumber, notificationSettings } = this.props;
    return (
      forwardingPhoneNumber ||
      (notificationSettings &&
        notificationSettings.find(
          (setting: NotificationSetting) =>
            setting.notificationType === NOTIFICATION_TYPES.INCOMING_TEXT_NOTIFICATION,
        ))
    );
  };

  render() {
    const { onPrev, onSkip, saving, handleSubmit, job, editing, change, submitting } = this.props;

    if (!job || !job.job_id) {
      return null;
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <JobFieldContactInfo job={job} />
        <JobFieldNotificationSettings
          jobId={job.job_id}
          isEditing
          isSubmitting={submitting || saving}
        />
        <JobFieldApplicantScoreThreshold job={job} change={change} isEditing />
        <JobFlowButtons
          disabled={!this.hasTextNotification()}
          onPrev={onPrev}
          onSkip={onSkip}
          editing={editing}
          saving={saving}
        />
      </form>
    );
  }
}

export const JobFlowNotifications = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm<JobFlowNotificationsFields, JobFlowNotificationsComponentProps>({
    form: FORM_NAME,
    enableReinitialize: true,
  })(JobFlowNotificationsComponent),
);
